import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { red } from "@mui/material/colors";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import get from "lodash/get";
import includes from "lodash/includes";
import { useState } from "react";
import Scroll from "react-scroll";
import { Sorty } from "../../../common/js/icons";
import schema from "./savedSearchesTable";

const StyledModalPaper = styled("div")(({ theme }) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    minWidth: "800px",
    maxHeight: "700px",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
}));

const StyledLoadingSpinner = styled("div")({
    position: "absolute",
    left: "50%",
    top: "60%",
    transform: "translate(-50%, -50%)",
});

const StyledDeleteButton = styled(Button)({
    border: "0px",
    color: red[500],
    "&:hover": {
        backgroundColor: red[100],
    },
});

const StyledSortable = styled("span")({
    paddingRight: "6px",
});

const StyledListingIdLink = styled("span")({
    "&:hover": {
        cursor: "pointer",
        textDecoration: "underline",
    },
    color: "#2C99D2 !important",
    fontWeight: "600 !important",
});

const SavedSearchesModal = (props) => {
    const {
        handleGridSort,
        showModal,
        savedSearchData,
        savedGroupData,
        isLoading,
        toggleSavedSearchesModal,
        searchType,
        runSavedSearch,
        runSavedGroup,
        tab,
        handleDeleteSavedSearch,
        handleDeleteSavedGroup,
    } = props;

    const [deleteDialog, setDeleteDialog] = useState(false);
    const [itemToDelete, setItemToDelete] = useState({});

    const toggleDeleteDialog = (open, item) => {
        setDeleteDialog(open);
        setItemToDelete(item);
    };

    const handleDelete = (key, tabType) => {
        setDeleteDialog(false);
        setItemToDelete({});
        if (tabType === "Search") {
            handleDeleteSavedSearch(key);
        } else if (tabType === "Group") {
            handleDeleteSavedGroup(key);
        }
    };

    const tabType = includes(["all_km_listings", "all_km_comps"], tab) ? "Search" : "Group";
    const searchTypeTitle = searchType === "listings" ? "Listings" : searchType === "comps" ? "Comps" : "Properties";
    const searchData =
        tabType === "Search" && savedSearchData
            ? savedSearchData
            : tabType === "Group" && savedGroupData
            ? savedGroupData
            : [];
    const tableName =
        tabType === "Group"
            ? "groups"
            : searchType === "property"
            ? "savedSearchesNoSelections"
            : "savedSearchesWithSelections";
    let Element = Scroll.Element;

    return (
        <div>
            <Modal aria-labelledby="saved-searches-modal" aria-describedby="view-saved-searches" open={showModal}>
                <StyledModalPaper>
                    {tabType === "Search" ? (
                        <h4 className="modal-title" style={{ paddingBottom: "25px", textAlign: "center" }}>
                            Saved Searches for {searchTypeTitle}
                        </h4>
                    ) : (
                        <h4 className="modal-title" style={{ paddingBottom: "25px", textAlign: "center" }}>
                            Saved Lists for {searchTypeTitle}
                        </h4>
                    )}
                    {tabType === "Search" ? (
                        <Grid container style={{ overflow: "auto" }} spacing={0}>
                            <Grid item xs style={{ minHeight: "25vh" }}>
                                <Element style={{ height: "560px", overflowY: "scroll", overflowX: "hidden" }}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                {schema.viewHeaders[tableName].map((x, i) => (
                                                    <TableCell key={`thc-${i}`}>
                                                        <div
                                                            onClick={() => handleGridSort(x.name, tableName)}
                                                            style={
                                                                x.name === "Search Name"
                                                                    ? searchType !== "property"
                                                                        ? {
                                                                              display: "inline-block",
                                                                              alignItems: "center",
                                                                              width: "360px",
                                                                          }
                                                                        : {
                                                                              display: "inline-block",
                                                                              alignItems: "center",
                                                                              width: "460px",
                                                                          }
                                                                    : x.name === "Delete Button"
                                                                    ? {
                                                                          display: "inline-block",
                                                                          alignItems: "center",
                                                                          paddingRight: 0,
                                                                      }
                                                                    : {
                                                                          display: "inline-block",
                                                                          alignItems: "center",
                                                                          minWidth: "110px",
                                                                      }
                                                            }
                                                        >
                                                            <StyledSortable>
                                                                {x.name !== "Delete Button" ? x.name : ""}
                                                            </StyledSortable>
                                                            {x.name !== "Delete Button" ? (
                                                                <div style={{ display: "inline-block" }}>
                                                                    <Sorty />
                                                                </div>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </div>
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {searchData.length !== 0
                                                ? searchData.map((x, i) =>
                                                      row(
                                                          x,
                                                          i,
                                                          isLoading,
                                                          searchType,
                                                          runSavedSearch,
                                                          runSavedGroup,
                                                          toggleDeleteDialog,
                                                          tableName
                                                      )
                                                  )
                                                : ""}
                                        </TableBody>
                                    </Table>
                                    {isLoading ? (
                                        <StyledLoadingSpinner style={{ marginTop: "25px" }}>
                                            <CircularProgress color="primary" />
                                        </StyledLoadingSpinner>
                                    ) : searchData.length === 0 ? (
                                        <div
                                            style={{
                                                margin: "auto",
                                                width: "25%",
                                                paddingTop: "150px",
                                                fontSize: "18px",
                                                color: "rgba(0, 0, 0, 0.30)",
                                            }}
                                        >
                                            No Saved Searches
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                </Element>
                            </Grid>
                        </Grid>
                    ) : (
                        <Grid container style={{ overflow: "auto" }} spacing={0}>
                            <Grid item xs style={{ minHeight: "25vh" }}>
                                <Element style={{ height: "560px", overflowY: "scroll", overflowX: "hidden" }}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                {schema.viewHeaders[tableName].map((x, i) => (
                                                    <TableCell key={`thc-${i}`}>
                                                        <div
                                                            onClick={() => handleGridSort(x.name, tableName)}
                                                            style={
                                                                x.name === "List Name"
                                                                    ? {
                                                                          display: "inline-block",
                                                                          alignItems: "center",
                                                                          width: "360px",
                                                                      }
                                                                    : x.name === "Delete Button"
                                                                    ? {
                                                                          display: "inline-block",
                                                                          alignItems: "center",
                                                                          paddingRight: 0,
                                                                      }
                                                                    : {
                                                                          display: "inline-block",
                                                                          alignItems: "center",
                                                                          minWidth: "110px",
                                                                      }
                                                            }
                                                        >
                                                            <StyledSortable>
                                                                {x.name !== "Delete Button" ? x.name : ""}
                                                            </StyledSortable>
                                                            {x.name !== "Delete Button" ? (
                                                                <div style={{ display: "inline-block" }}>
                                                                    <Sorty />
                                                                </div>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </div>
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {searchData.length !== 0 && schema.viewHeaders[tableName] !== undefined
                                                ? searchData.map((x, i) =>
                                                      row(
                                                          x,
                                                          i,
                                                          isLoading,
                                                          searchType,
                                                          runSavedSearch,
                                                          runSavedGroup,
                                                          toggleDeleteDialog,
                                                          tableName
                                                      )
                                                  )
                                                : ""}
                                        </TableBody>
                                    </Table>
                                    {isLoading ? (
                                        <StyledLoadingSpinner style={{ marginTop: "25px" }}>
                                            <CircularProgress color="primary" />
                                        </StyledLoadingSpinner>
                                    ) : searchData.length === 0 ? (
                                        <div
                                            style={{
                                                margin: "auto",
                                                width: "25%",
                                                paddingTop: "150px",
                                                fontSize: "18px",
                                                color: "rgba(0, 0, 0, 0.30)",
                                            }}
                                        >
                                            No Saved Groups
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                </Element>
                            </Grid>
                        </Grid>
                    )}
                    <Grid container justifyContent="flex-end">
                        <Grid item>
                            <Button
                                variant="outlined"
                                style={{ marginTop: "25px", marginRight: "20px" }}
                                onClick={() => toggleSavedSearchesModal(false)}
                            >
                                Exit
                            </Button>
                        </Grid>
                    </Grid>
                </StyledModalPaper>
            </Modal>

            <Dialog open={deleteDialog} maxWidth="sm" aria-labelledby="confirmation-dialog-title">
                <DialogTitle style={{ textAlign: "center" }} id="confirmation-dialog-title">
                    Delete Saved Search?
                </DialogTitle>
                <DialogContent>
                    Are you sure you want to delete this Saved {tabType}? You will not be able to recover the {tabType}.
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => toggleDeleteDialog(false, {})} color="primary">
                        Cancel
                    </Button>
                    <Button
                        onClick={() =>
                            tabType === "Search"
                                ? handleDelete(get(itemToDelete, "savedSearchKey", null), tabType)
                                : handleDelete(get(itemToDelete, "savedGroupKey", null), tabType)
                        }
                        color="primary"
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

const row = (x, i, isLoading, searchType, runSavedSearch, runSavedGroup, toggleDeleteDialog, tableName) => {
    return isLoading ? null : (
        <TableRow key={`tr-${i}`} selectable="false">
            {schema.viewHeaders[tableName].map((y, k) => (
                <TableCell
                    key={`trc-${k}`}
                    style={
                        y.name === "Delete Button"
                            ? { paddingRight: "10px", paddingLeft: 0 }
                            : y.name === "Retain Selections?"
                            ? { textAlign: "center" }
                            : { paddingRight: 0 }
                    }
                >
                    {y.name === "Delete Button" ? (
                        <StyledDeleteButton variant="outlined" onClick={() => toggleDeleteDialog(true, x)}>
                            Delete
                        </StyledDeleteButton>
                    ) : y.name === "Retain Selections?" ? (
                        <StyledSortable style={{ minWidth: "100px" }}>
                            {get(x, y.prop, false) ? "Yes" : "No"}
                        </StyledSortable>
                    ) : y.transform ? (
                        <StyledSortable style={{ minWidth: "100px" }}>
                            {y.transform(get(x, y.prop, null))}
                        </StyledSortable>
                    ) : (
                        <div
                            onClick={() =>
                                tableName === "groups"
                                    ? runSavedGroup(get(x, "savedGroupKey", null), get(x, "selectedItems", null))
                                    : runSavedSearch(get(x, "savedSearchKey", null))
                            }
                        >
                            {y.name === "List Name" || y.name === "Search Name" ? (
                                <StyledListingIdLink style={{ minWidth: "100px" }}>
                                    {get(x, y.prop, "N/A")}
                                </StyledListingIdLink>
                            ) : (
                                <StyledSortable style={{ minWidth: "100px" }}>{get(x, y.prop, "N/A")}</StyledSortable>
                            )}
                        </div>
                    )}
                </TableCell>
            ))}
        </TableRow>
    );
};

export default SavedSearchesModal;
